export const sortByNumber = (array: any, labelAttribute: string, isDec?: boolean) => {
    return !isDec ? array.sort((a: any, b: any) => a[labelAttribute] - b[labelAttribute]) : array.sort((a: any, b: any) => b[labelAttribute] - a[labelAttribute])
}
